import React from 'react'

export default function NotFound(): JSX.Element {
  return <div>404 not found</div>
}
